import BaseChart from '../baseChart';

// type Props = {
//   /** An additional class. */
//   className: ?string,
//   /* Series Data array for column chart */
//   data: [],
//   /* Set additional options for column chart. */
//   options: {},
//   /* Theme of the column chart. */
//   theme: string,
// };

export default function Column(props) {
  const { className, data, options, ...otherProps } = props;

  const defaultOptions = {
    plotOptions: {
      column: {
        pointPadding: 0.15,
        borderWidth: 0,
        edgeWidth: 0,
        groupPadding: 0,
      },
    },
  };

  return (
    <BaseChart
      className={className}
      chartType="column"
      data={data}
      defaultOptions={defaultOptions}
      options={options}
      {...otherProps}
    />
  );
}
